import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  environmentConfig = inject(ENVIRONMENT_CONFIG);

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authService.logout();
          void this.router.navigateByUrl(this.environmentConfig.routes['sign-in']);
        }
        return throwError(err);
      })
    );
  }
}
